













































































import dayjs from 'dayjs'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { PublicVoucher } from '@/domain/entities/PublicVoucher'
import Badge from '@/app/ui/components/Badge/index.vue'

@Component({
  components: {
    Badge,
  },
})
export default class PublicVoucherItem extends Vue {
  @Prop() private isGuest!: boolean
  @Prop() private publicVoucher!: PublicVoucher

  get statusBadgeType() {
    if (
      this.publicVoucher?.status?.toLowerCase() === 'expired' ||
      this.publicVoucher?.status?.toLowerCase() === 'cancelled'
    ) {
      return 'error'
    } else if (
      this.publicVoucher?.status?.toLowerCase() === 'active' ||
      this.publicVoucher?.status?.toLowerCase() === 'published'
    ) {
      return 'success'
    } else {
      return 'warning'
    }
  }

  get isPendingOrActive() {
    return (
      this.publicVoucher.status === 'ACTIVE' ||
      this.publicVoucher.status === 'PENDING'
    )
  }

  private getPeriod(startDate: string, endDate: string) {
    return `${dayjs(startDate).format(
      'DD MMMM YYYY'
    )} - ${dayjs(endDate).format('DD MMMM YYYY')}`
  }

  private formatDate(date: string) {
    return dayjs(date).format('DD MMMM YYYY HH:mm [WIB]')
  }
}
